import fetchUrl from 'utils/fetch';

export function updatePostpone(id, date) {
  return fetchUrl(`/news/${id}/postpone?date=${date}`, {
    method: 'PUT',
  });
}



// WEBPACK FOOTER //
// ./src/modules/news/api/index.js